/**
 * The URL segment the documents tab lives at under a Clarity domain: `/clarity/d/:domainId/documents`.
 *
 * Shared because four places must agree on it — the application's route, the tab strip's tab id, and
 * the two links into an open document (the in-app navigation and the share URL). A tab whose id has
 * drifted from the route does not throw, it renders an empty page, so all of them read this one
 * declaration rather than separate literals. `type:util` is the one layer every one of them may reach.
 */
export const CLARITY_DOCUMENTS_ROUTE_SEGMENT = 'documents';
